module.exports = __webpack_public_path__ + "img/symbol_1.42519694.png";